import React from 'react';
import { Link } from 'react-router-dom';
import { Layout } from '../components/layout/Layout';
import { PageHero, FeatureGrid, ContentSection, SEOContent, CTASection } from '../components/shared';
import { pageHeroImages } from '../data/mock';
import { ArrowRight } from 'lucide-react';

const hausarztFeatures = [
  {
    id: '2A1',
    title: 'Akutsprechstunde',
    description: 'Schnelle Hilfe bei akuten Beschwerden – ohne Termin.',
    image: '/images/Akutsprechstunden_EKG.webp',
    link: '/leistungen/hausarzt/akut'
  },
  {
    id: '2A2',
    title: 'Allgemeine Sprechstunde',
    description: 'Beratung, Untersuchung und Therapie nach Terminvereinbarung.',
    image: '/images/hausarzt.webp',
    link: '/leistungen/hausarzt/sprechstunde'
  },
  {
    id: '2A3',
    title: 'Hausbesuche',
    description: 'Medizinische Versorgung bei Ihnen zu Hause.',
    image: '/images/Hausbesuche.webp',
    link: '/leistungen/hausarzt/hausbesuche'
  },
  {
    id: '2A4',
    title: 'Krankschreibungen & eAU',
    description: 'Unkomplizierte Krankmeldung und digitale Übermittlung.',
    image: '/images/Content_Behandlung_5.webp',
    link: '/leistungen/hausarzt/krankschreibung'
  },
  {
    id: '2A5',
    title: 'Impfungen & Impfberatung',
    description: 'Schutz und Beratung rund um Impfungen.',
    image: '/images/Content_Behandlung_6.webp',
    link: '/leistungen/hausarzt/impfungen'
  },
  {
    id: '2A6',
    title: 'Kindervorsorge (U3–J1)',
    description: 'Begleitung der kindlichen Entwicklung.',
    image: '/images/Kindervorsorge_Hero_opt.webp',
    link: '/leistungen/hausarzt/kindervorsorge'
  },
  {
    id: '2A7',
    title: 'Psychosomatische Grundversorgung',
    description: 'Unterstützung bei seelischen und körperlichen Zusammenhängen.',
    image: '/images/Psychosomatik.webp',
    link: '/leistungen/hausarzt/psychosomatik'
  }
];

export const HausarztPage = () => {
  return (
    <Layout>
      <PageHero
        title="Hausärztliche Versorgung im Medicum Diez"
        subtitle="Ihr erster Ansprechpartner für Vorsorge, akute Beschwerden und langfristige Betreuung."
        backgroundImage={pageHeroImages.hausarzt}
        ctaText="Jetzt Termin vereinbaren"
      />

      <FeatureGrid
        title="Unsere hausärztlichen Leistungen"
        features={hausarztFeatures}
        columns={4}
      />

      <ContentSection
        title="Ihr Hausarzt als Begleiter für alle Lebensphasen"
        content="Wir begleiten Sie und Ihre Familie von der Vorsorge über akute Erkrankungen bis zur langfristigen Therapie chronischer Beschwerden – persönlich, verständlich und koordiniert."
        image="/images/Vertrauensvoller_Ansprechpartner.webp"
        backgroundColor="white"
      />

      <ContentSection
        title="Koordination mit Fachärzten und Diagnostik"
        content={
          <div>
            <p className="text-[#0b382a]/80 leading-relaxed mb-4">
              Durch die enge Zusammenarbeit im Medicum Diez können wir Befunde schnell besprechen und Therapieentscheidungen gemeinsam mit Kardiologie, Diagnostik und weiteren Fachrichtungen treffen.
            </p>
            <div className="flex flex-wrap gap-4">
              <Link to="/leistungen/diagnostik" className="inline-flex items-center gap-2 text-[#b5a05f] hover:text-[#9a8850] font-medium transition-colors">
                Diagnostik-Zentrum
                <ArrowRight className="w-4 h-4" />
              </Link>
              <Link to="/leistungen/kardiologie" className="inline-flex items-center gap-2 text-[#b5a05f] hover:text-[#9a8850] font-medium transition-colors">
                Kardiologie & Herz-Check
                <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </div>
        }
        image="/images/Medizin_aus_Ueberzeugung.webp"
        imagePosition="left"
        backgroundColor="gray"
      />

      <SEOContent
        title="Hausarztpraxis in Diez und Limburg"
        content="Die Gemeinschaftspraxis Dres. von Bergh im Medicum Diez bietet hausärztliche Betreuung, Akutsprechstunde, Vorsorge, Impfungen, Kindervorsorge und psychosomatische Grundversorgung. Als Ihr Hausarzt in Diez und Limburg koordinieren wir Ihre medizinische Versorgung im Rhein-Lahn-Kreis."
      />

      <CTASection
        title="Jetzt Termin vereinbaren"
        subtitle="Vereinbaren Sie Ihren Termin in der hausärztlichen Sprechstunde online oder telefonisch."
        buttonText="Jetzt Termin vereinbaren"
      />
    </Layout>
  );
};

export default HausarztPage;
